// @ts-strict-ignore
import { cssVar, getLuminance } from 'polished';
import type { DropdownOption } from './NodeEditorDrawer/types';

export function capitalizeString(text: string): string {
  return text[0].toUpperCase() + text.slice(1);
}

/**
 * helper to format a color string to a format CSS understands.
 * mostly used to convert from formats like "FC6655" to "#FC6655"
 * @param color
 * @returns color in a CSS-compatible color
 */
export function formatColor(color: string): string {
  if (!color.includes('var(') && color.charAt(0) !== '#') {
    return `#${color}`;
  }

  return color;
}

export function getColorFromVariable(color: string): string {
  if (color.includes('var(')) {
    return `${cssVar(color.replace(/var\((.+)\)/, '$1'))}`;
  }

  return formatColor(color);
}

export function getIconColorForBackgroundColor(backgroundColor: string): string {
  // This shouldn't really happen but can be useful for workflows with
  // corrupted outcome reasons - it will display without crashing the page.
  if (!backgroundColor) {
    return '';
  }
  // 0.2 is sort-of a magic number
  return getLuminance(getColorFromVariable(backgroundColor)) >= 0.2 ? 'black' : 'white';
}

/**
 * this helper is related to rule/expression building and should eventually be moved to
 * common abstraction for threshold, expression and mla building.
 */
export function getSelectedOption({
  incomingValue, options,
}: {
  incomingValue: string;
  options: DropdownOption[];
}) {
  let matchingOptionItem: DropdownOption;
  options.some(item => {
    if (item.value === incomingValue) {
      matchingOptionItem = item;
      return true;
    }

    if (item.options) {
      const matchingNestedValue = item.options.find(
        nestedValue => nestedValue.value === incomingValue);
      if (matchingNestedValue) {
        matchingOptionItem = matchingNestedValue;
        return true;
      }
    }

    return false;
  });

  return matchingOptionItem;
}

/**
 * this helper is related to rule/expression building and should eventually be moved to
 * common abstraction for threshold, expression and mla building.
 */
export const onEscKeyFromRuleDropdown = (
  e: React.KeyboardEvent<HTMLInputElement>,
  activeInputValue: {
    value: string;
    path: string;
    initialValue: boolean;
  },
  setActiveInputValue: ({
    value,
    path,
    initialValue,
  }) => void,
  multiSelectRef: React.MutableRefObject<any>,
) => {
  if (activeInputValue.value !== '') {
    setActiveInputValue({
      value: '',
      path: '',
      initialValue: false,
    });
  } else {
    multiSelectRef?.current?.blur();
  }

  e.preventDefault();
  e.stopPropagation();
};
